<template>
  <Notification :description="$t('rc_disconnected_no_alternative_notification')" v-bind="$attrs">
    <template #ctaContent>
      <div class="tw:mt-3 tw:md:mt-0">
        <BaseLinkButton
          :href="supportCenterUrl"
          rel="noopener noreferrer"
          target="_blank"
          class="tw:w-full tw:font-bold tw:text-blue-800 tw:text-nowrap"
        >
          {{ $t('notification_action_contact_us') }}
        </BaseLinkButton>
      </div>
    </template>
  </Notification>
</template>

<script setup>
import { computed } from 'vue'

import BaseLinkButton from '@/components/base/buttons/BaseLinkButton.vue'
import Notification from '@/components/productNotifications/Notification.vue'

import { getContactUrl } from '@/utils/Utility.ts'
import { selectedAccommodationId } from '@/layouts/queries'
import { useCampaign } from '@/components/rateConnect/queries'
import { useStudioPlusCampaign } from '@/components/payment/queries'
import { useSessionValues } from '@/composables/useSessionValues'

const { userId, language } = useSessionValues()
const { campaignsData } = useCampaign(selectedAccommodationId)
const { studioPlusCampaign } = useStudioPlusCampaign(selectedAccommodationId)
const isPaidClient = computed(
  () =>
    Boolean(studioPlusCampaign.value) ||
    (Array.isArray(campaignsData.value) ? campaignsData.value.length > 0 : Boolean(campaignsData.value))
)
const supportCenterUrl = computed(() =>
  getContactUrl(language.value, userId.value, selectedAccommodationId.value, isPaidClient.value)
)
</script>
